/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";

// Infterface for component Props
interface WhyAskingComponentProps {
  handlePopup: () => void;
  t?: any;
}

// Infterface for component State
interface WhyAskingComponentState { }

/**
 * Reusable React component - Why We Asking.
 *
 * @namespace WhyAskingComponent
 */

class WhyAskingComponent extends Component<
  WhyAskingComponentProps,
  WhyAskingComponentState
> {
  // constructor(props: WhyAskingComponentProps) {
  //   super(props);
  // }

  /**
   * This method is used for handle popup Change
   *
   */
  handlePopup = (e?: any) => {
    if (this.props.handlePopup) {
      this.props.handlePopup();
    }
  };

  render() {
    return (
      <div tabIndex={0} role="link" className="we-asking-wrapper" onClick={this.handlePopup}
        onKeyPress={(e) => { if (e.key === "Enter" || e.key === " ") { this.handlePopup(e) } }}>
        <div className="inner-wrapper">
          <span className="icon green-info"></span>
          <span className="label">
            {this.props.t("common.why_are_we_asking_this")}
          </span>
        </div>
      </div>
    );
  }
}

export default WhyAskingComponent;
